import React from "react";

import { Breadcrumbs, IconButton, useMediaQuery } from "@mui/material";

import { useTranslation } from "react-i18next";

import { Badge } from "reactstrap";

import SubHeader from "Components/Generic/SubHeader";

import useStyles from "./styles";
import { NavigateNext, Menu as MenuIcon } from "@mui/icons-material";
import { Company } from "Models/company";
import { SettingPageTab } from "./types";
import { isMoving } from "Util/validation";
import { useAppState } from "Context/StateContext";

type SubNavItem = {
  open: boolean;
  items: NavItem[];
};

type NavItem = {
  key?: string;
  label: string;
  currentSubPage?: string;
  subitems?: SubNavItem;
  iconRight?: boolean;
  action: () => void;
};

export const SettingsPageTitle = ({
  company,
  tab,
  swipeableIsOpen,
  setSwipeableIsOpen,
}: {
  company: Company;
  tab: SettingPageTab;
  swipeableIsOpen: boolean;
  setSwipeableIsOpen: (isOpen: boolean) => void;
}) => {
  const classes = useStyles();
  const { t: translate } = useTranslation();
  const { currentUser } = useAppState();

  if (isMoving(currentUser?.company)) {
    return null;
  }

  return (
    <SubHeader>
      <div
        style={{
          display: "flex",
          flex: 1,
          flexDirection: useMediaQuery("(max-width: 600px)") ? "column" : "row",
          alignItems: useMediaQuery("(max-width: 600px)") ? "flex-start" : "center",
        }}
      >
        {isMoving(currentUser?.company) ? null : (
          <Breadcrumbs
            data-cy="breadcrumbs"
            separator={<NavigateNext />}
            aria-label="breadcrumb"
            className={classes.headerBreadcrumb}
          >
            <span data-cy="breadcrumbsTitle" className={classes.headerBreadcrumbTitle}>
              {translate("settings")}
            </span>
            <span data-cy="breadcrumbsTitle" className={classes.headerBreadcrumbTitle}>
              {translate(tab?.parent)}
            </span>
            {tab?.child?.parent ? (
              <span
                data-cy="breadcrumbsSubtitle"
                className={`${classes.headerBreadcrumbTitle} active`}
              >
                {translate(tab?.child?.parent)}
              </span>
            ) : (
              ""
            )}
          </Breadcrumbs>
        )}
        {!isMoving(currentUser?.company) && company?.profile && company?.profile?.name && (
          <div>
            <Badge className={classes.settingsHeaderBadge}>{company.status} Company</Badge>
            <Badge className={classes.settingsHeaderVersion}>{company.profile?.name}</Badge>
          </div>
        )}
      </div>
      <div
        style={{
          display: useMediaQuery("(max-width: 600px)") ? "flex" : "none",
          width: "20%",
          alignItems: "center",
          justifyContent: "flex-end",
        }}
      >
        <IconButton onClick={() => setSwipeableIsOpen(!swipeableIsOpen)}>
          <MenuIcon htmlColor="#15375C" />
        </IconButton>
      </div>
    </SubHeader>
  );
};
